import { render, staticRenderFns } from "./TransferTask.vue?vue&type=template&id=88eb0c46&scoped=true"
import script from "./TransferTask.vue?vue&type=script&lang=js"
export * from "./TransferTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88eb0c46",
  null
  
)

export default component.exports